import { Contato, FormaPagamento } from "src/components/vendas/types";

export enum SITUACAO_COMPONENTE {
    SALDO = 'saldo',
    ORIGINAL = 'original',
    SUBSTITUIDO = 'substituido',
    NOVO = 'novo',
    ALTERADO = 'alterado',
    EXCLUIDO = 'excluido',
}

export interface Componente {
    componente?: ComponenteProjeto;
    componente_id: number;
    quantidade: number;
    valor_unitario: number;
    valor: number;
    saldo: number;
    data_saldo: string | null;
    checked?: boolean;
    novo?: boolean;
    situacao: SITUACAO_COMPONENTE;
    modelo?: string;
}


export interface Projeto {
    id?: number;
    codigo_venda: string;
    situacao: string;
    potencia: number;
    valor: number;
    valor_servico: number;
    valor_pagamento: number;
    estabelecimento_id?: number;
    estabelecimento_modificado_id: number | null;
    justificativa: string | null;
    bloqueio: string | null;
    created_at: string | null;
    updated_at: string | null;
    usuario_id: number;
    codigo_pedido: string | null;
    data_integracao: string | null;
    distribuidor?: Contato;
    revenda?: Contato;
    cliente?: Contato;
    forma_pagamento?: FormaPagamento;
    ev?: Contato;
    componentes: Componente[];
    modificados: Modificado[];
    data_previsao_faturamento?: string | null;
    data_pagamento?: string | null;
    notificacoes?: Notificacao[];
}

export interface Notificacao {
    observacao: string;
    bloqueio: boolean;
}


export interface ComponenteProjeto {
    id: number;
    altura: number;
    categoria_componentes_id: number;
    comprimento: number;
    considerar_calculo: boolean;
    created_at: Date;
    dados_integracao: any;
    descricao: string;
    descricao_comercial: string;
    exibir_listagem: boolean;
    fabricante_id: number | null;
    largura: number;
    modelo: string;
    nome: string;
    nome_comercial: string;
    peso: number;
    segmento: string;
    tempo_garantia: number;
    tempo_garantia_unidade: string;
    updated_at: Date;
    venda: string;
}

export interface Modificado {
    componente?: ComponenteProjeto;
    componente_id: number;
    componente_substituido_id: number | null;
    situacao: SITUACAO_COMPONENTE;
    quantidade: number;
    valor_unitario: number;
    valor: number;
    saldo: number;
    data_saldo: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    usuario_id?: number;
}

export interface ProjetoComponentesEdicao extends Partial<Componente> {
    componente_substituto?: Modificado | null
    quantidade_original: number
}

export interface DadosCalculoPedido {
    componentes: ComponenteCalculo[];
    modificados: ComponenteCalculo[];
}


export interface ComponenteCalculo {
    componente_id: number;
    quantidade: number;
    valor: number;
    valor_unitario: number;
    categoria_componentes_id: number;
    peso: number;
    altura?: number;
    largura?: number;
    potencia?: number;
}

export interface PedidoCalculoResponse {
    componentes: ComponentesPedidoCalculo;
    modificados: ComponentesPedidoCalculo;
}

export interface ComponentesPedidoCalculo {
    area_total: number;
    peso_gerador: number;
    peso_telhado: number;
    valor: number;
    potencia_gerador: number;
}

export interface IModeloEmail {
    nome: string;
    id: number;
    grupo: string;
}